import React from 'react';
import { City, State } from './types';
import { StateRow } from './StateRow';
import { StateNav } from './StateNav';

export type StateListProps = {
  states: (State & { topCities: City[]; stateJobsPageUrl: string })[];
  seeMoreText: string;
  seeAllText: string;
  title: string;
  description: string;
};

export const StateList = ({ states, seeMoreText, seeAllText, title, description }: StateListProps) => {
  return (
    <div className="lg:max-w-7xl px-7 xl:px-0 m-auto py-10 lg:pb-24 lg:pt-32 text-kale">
      <h1 className="font-heading text-hxl lg:text-h2xl mb-6">{title}</h1>
      <p className="text-xl pb-4">{description}</p>
      {states.length > 20 && <StateNav states={states} />}
      <div
        className="state-card-container"
      >
        {states.map((state) => {
          return <StateRow key={state.abbreviation} state={state} seeAllText={seeAllText} />;
        })}
      </div>
    </div>
  );
};
